import React, { useEffect, useState } from "react";

interface HorizontalColorPickerProps {
  orderInfoColor: string;
  preset: string[];
  setColor: (color: string) => void;
}

function HorizontalColorPicker({
  orderInfoColor,
  preset,
  setColor,
}: HorizontalColorPickerProps) {
  const [selectedColor, setSelectedColor] = useState<string>(orderInfoColor);
  const [buttonIndex, setButtonIndex] = useState<number>(-1);

  useEffect(() => {
    if (selectedColor) {
      setColor(selectedColor);
    }
  }, [selectedColor]);

  function handleClick(color: string, index: number) {
    setSelectedColor(color);
    setButtonIndex(index);
  }

  return (
    <div className={"product-canvas__color-picker-wrapper"}>
      {preset.map((color, index) => (
        <button
          key={`${index}`}
          onClick={() => {
            handleClick(color, index);
          }}
          className={"product-canvas__color-picker-btn"}
          style={Object.assign(
            buttonIndex === index || orderInfoColor === color
              ? { borderColor: "white" }
              : {},
            { backgroundColor: color }
          )}
          type={"button"}
        />
      ))}
    </div>
  );
}

export default HorizontalColorPicker;
